// @flow
import * as React from 'react';
import { sprintf } from 'sprintf-js';
import styled from 'styled-components';
import { createCookie } from 'utils/cookies';
import Link from 'components/Link';
import { LANGUAGES } from 'utils/constants';
import LanguageIcon from 'language-selection.svg';

const StyledLanguageIcon = styled(LanguageIcon)`
  width: 16px;
  height: 16px;
  opacity: 0.7;
`;

const LanguageLinks = ({
  className,
  url,
  showIcon = true
}: {
  className?: string,
  url: Object,
  showIcon?: boolean
}) => (
  <div className={className}>
    {showIcon && <StyledLanguageIcon />}
    {Object.keys(LANGUAGES).map(key => (
      <Link
        key={key}
        href={url[key] || null}
        rel="nofollow"
        data-qa-id={
          url[key] ? `locale-link-${key}` : `disabled-locale-link-${key}`
        }
        onClick={() => createCookie('_LOCALE_', key, 1825)}
        title={
          !url[key]
            ? sprintf(
                getText('This page is currently not available in %(language)s'),
                { language: LANGUAGES[key] }
              )
            : ''
        }
      >
        {LANGUAGES[key]}
      </Link>
    ))}
  </div>
);

export default LanguageLinks;
